import { render, staticRenderFns } from "./Meal.vue?vue&type=template&id=a9861a0a&scoped=true&"
import script from "./Meal.vue?vue&type=script&lang=js&"
export * from "./Meal.vue?vue&type=script&lang=js&"
import style0 from "./Meal.vue?vue&type=style&index=0&id=a9861a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9861a0a",
  null
  
)

export default component.exports